import React from "react";
import { Col, FormGroup, Label, Row } from "reactstrap";
import { ToggleComponentProps } from "../../../../../../Types/LetterBox.type";

export default function ToggleComponent({ ccShow, bccShow, register }: ToggleComponentProps) {
  return (
    <>
      <FormGroup>
        <Row className={`collapse ${ccShow ? "show" : ""}`} id="collapseCc">
          <Col sm={2}>
            <Label className="col-form-label" htmlFor="composeCc">
              {"Cc"} :
            </Label>
          </Col>
          <Col sm={10}>
            <input className="form-control" id="composeCc" type="email" {...register("ccEmail")} autoComplete="off" />
          </Col>
        </Row>
      </FormGroup>
      <FormGroup>
        <Row className={`collapse ${bccShow ? "show" : ""}`} id="collapseBcc">
          <Col sm={2}>
            <Label className="col-form-label" htmlFor="composeBcc">
              {"Bcc"} :
            </Label>
          </Col>
          <Col sm={10}>
            <input className="form-control" id="composeBcc" type="email" {...register("bccEmail")} autoComplete="off" />
          </Col>
        </Row>
      </FormGroup>
    </>
  );
}
